import React, {Component} from 'react'
import {Checkbox, Col, Form, Input, Row} from 'antd'
import {get} from 'lodash'

const {TextArea} = Input

class BookingForm extends Component {
  render() {
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {booking} = this.props
    return (
      <Form>
        <Row>
          <Row>
            <Col span={12}>
              <Form.Item {...formItemLayout} label={'Line Name'}>
                {getFieldDecorator('name', {
                  initialValue: get(booking, 'name'),
                })(<Input placeholder={'Line Name'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                {...{
                  labelCol: {
                    sm: {span: 3},
                  },
                  wrapperCol: {
                    sm: {span: 21},
                  },
                }}
                label={'Description'}>
                {getFieldDecorator('description', {
                  initialValue: get(booking, 'description'),
                })(<TextArea placeholder={'Description'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Vehicle'}>
              {getFieldDecorator('booking.vehicle.name', {
                initialValue: get(booking, 'booking.vehicle.name'),
              })(<Input placeholder={'Vehicles'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Plate No'}>
              {getFieldDecorator('booking.vehicle.plate', {
                initialValue: get(booking, 'booking.vehicle.plate'),
              })(<Input placeholder={'Plate No'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Driver Name'}>
              {getFieldDecorator('booking.vehicle.driver', {
                initialValue: get(booking, 'booking.vehicle.driver'),
              })(<Input placeholder={'Driver Name'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Driver Phone'}>
              {getFieldDecorator('booking.vehicle.driverPhone', {
                initialValue: get(booking, 'booking.vehicle.driverPhone'),
              })(<Input placeholder={'Driver Phone'} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Fuel Tag'}>
              {getFieldDecorator('booking.vehicle.fuelTag', {
                initialValue: get(booking, 'booking.vehicle.fuelTag'),
              })(<Input placeholder={'Fuel Tag'} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

BookingForm.propTypes = {}
BookingForm.defaultProps = {}

export default Form.create()(BookingForm)
